import api from './api';

// Retrieve all page contents
export const getPageContents = async () => {
  try {
    const response = await api.get('/pagecontents'); // Updated endpoint to match backend route
    return response.data || [];
  } catch (error) {
    console.error('Error fetching page contents:', error.response?.data || error.message);
    throw error;
  }
};

// Retrieve a single page content by ID
export const getPageContentById = async (id) => {
  try {
    const response = await api.get(`/pagecontents/${id}`); // Updated endpoint to match backend route
    return response.data;
  } catch (error) {
    console.error(`Error fetching page content with ID ${id}:`, error.response?.data || error.message);
    throw error;
  }
};

// Create a new page content
export const createPageContent = async (pageContentData) => {
  try {
    const response = await api.post('/pagecontents', pageContentData); // Updated endpoint to match backend route
    return response.data;
  } catch (error) {
    console.error('Error creating page content:', error.response?.data || error.message);
    throw error;
  }
};

// Update an existing page content by ID
export const updatePageContent = async (id, pageContentData) => {
  try {
    await api.put(`/pagecontents/${id}`, pageContentData); // Updated endpoint to match backend route
  } catch (error) {
    console.error(`Error updating page content with ID ${id}:`, error.response?.data || error.message);
    throw error;
  }
};

// Delete a page content by ID
export const deletePageContent = async (id) => {
  try {
    await api.delete(`/pagecontents/${id}`); // Updated endpoint to match backend route
  } catch (error) {
    console.error(`Error deleting page content with ID ${id}:`, error.response?.data || error.message);
    throw error;
  }
};

export default {
  getPageContents,
  getPageContentById,
  createPageContent,
  updatePageContent,
  deletePageContent,
};
